// Spatial layers source names
export const SOURCE_911INFORM = '911inform';
export const SOURCE_CRG = 'crg';
export const SOURCE_GEOCOMM = 'geocomm';
export const SOURCE_AIR_AMBULANCE = 'air_ambulance';
export const STATIC_LAYER_MIN_ZOOM = 13;

/**
 * Whether a static spatial layer's visibility is gated by STATIC_LAYER_MIN_ZOOM.
 * Air ambulance landing zones must remain visible when zoomed out.
 */
export const isStaticLayerZoomGated = spatialLayer => {
  return spatialLayer?.source !== SOURCE_AIR_AMBULANCE;
};

/**
 * Resolve deck.gl visibility for a static spatial layer at the current zoom.
 */
export const getStaticLayerVisibleAtZoom = (spatialLayer, zoomLevel) => {
  if (!isStaticLayerZoomGated(spatialLayer)) {
    return true;
  }

  return zoomLevel >= STATIC_LAYER_MIN_ZOOM;
};
